import { PrivacyPolicyScreen } from 'app/features/legal/privacy-policy-screen'
import { HomeLayout } from 'components/home/HomeLayout'
import { NextSeo } from 'next-seo'

import { NextPageWithLayout } from './_app'

export const Page: NextPageWithLayout = () => {
  return (
    <>
      <NextSeo title="Privacy Policy" />
      <PrivacyPolicyScreen />
    </>
  )
}

Page.getLayout = (page) => <HomeLayout>{page}</HomeLayout>

export default Page
